import { render, staticRenderFns } from "./MedlemsListe.vue?vue&type=template&id=06097a7a&scoped=true&"
import script from "./MedlemsListe.vue?vue&type=script&lang=js&"
export * from "./MedlemsListe.vue?vue&type=script&lang=js&"
import style0 from "./MedlemsListe.vue?vue&type=style&index=0&id=06097a7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06097a7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VContainer,VDataTable,VSimpleCheckbox,VSkeletonLoader})
